






































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./close_add.vue";

@Component({
  components: {
    Add
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType: string = "stadium/closeList";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "开始时间", dataIndex: "time_start" },
    { title: "结束时间", dataIndex: "time_end" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "更新时间", dataIndex: "updated_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData(
      {
        stadium_id: this.stadiumId
      },
      false
    );
  }

  handleReopen(id: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要恢复营业吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/closeReopen", {
          close_id: id
        });
        if (res && res.Message && res.Message == "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }
}
